import { apiURL } from '../helpers/config';

export const qrOrderingApiURL = process.env.REACT_APP_QR_ORDERING_URL
  || apiURL?.replace(/api\/v1\/?$/, 'bQrOrdering/');
